import { put, takeLatest, all, call, fork, takeEvery } from "redux-saga/effects";
import { tenantManagementActions } from "../../constants/actionTypes";
import {
  tenantActionSuccess,
  playPauseTenantError,
  setTenantListData,
  setTenantListError,
  viewTenantSuccess,
  setTenantLogoData,
  setTenantLogoError,
  setAccountManagers,
  setAccountManagersError,
  setCsmAdmins,
  setCsmAdminsError,
  setMachineCatalogError,
  setMachineCatalogs,
  setTenantCreationData,
  setTenantDetailsById,
  setTenantDetailsErrorById,
  successPricingProfile,
  errorPricingProfile,
  setQuotaFormSuccess,
  setQuotaFormGetSuccess,
  setQuotaFormUpdateSuccess,
  notificationFormSuccess,
  notificationFormGetSuccess,
  notificationFormUpdateSuccess,
  setPricingProfileCreateSuccess,
  setPricingProfileCreateError,
  setPricingProfileEditSuccess,
  setPricingProfileEditError,
  setTenantSummary,
  setTenantSummaryError,
  tenantDeleteDataSuccess,
  setExtAndExpData,
  setExtAndExpDataError,
  setCreateExtAndExpData,
  setCreateExtAndExpError,
  setUpdateExtAndExpError,
  setUpdateExtAndExp,
  setUploadTemplateHtmlSuccess,
  setUploadTemplateHtmlError,
  setHtmlTemplateListSuccess,
  setHtmlTemplateListError,
  setTenantSettingsData,
  setTenantSettingsError,
  setTenantListLoading,
  setTenantListDataPaginated,
} from "../actions/tenantManagement";
import { commonLoaderSuccess } from "../actions/common";
import {
  deleteTenantApi,
  fetchTenantListData,
  playPauseTenantApi,
  createTenantApi,
  editTenantApi,
  viewTenantApi,
  getTenantUserList,
  getMachineCatalogs,
  getTenantDetailsByID,
  pricingSummeryApi,
  setQuotaFormApi,
  setQuotaFormGetApi,
  setQuotaFormUpdateApi,
  notificationSettingFormApi,
  notificationSettingGetApi,
  notificationSettingUpdateApi,
  createPricingProfileApi,
  editPricingProfileApi,
  fetchTenantSummary,
  getExtAndExpData,
  createExtAndExpApi,
  updateExtAndExpApi,
  uploadHtmlTemplate,
  fetchHtmlTemplateList,
  fetchTenantSettings,
} from "../api/tenantManagement";
import { statusCode } from "../../constants/apis/apiStatus";
import { uploadTemplateLogo } from "../api/resourceManager";
import { toastNotification } from "../../utils/toast";
import { toasterFlags } from "../../constants/componentConstants";

export function* fetchTenantListFunction({ payload }) {
  try {
    const data = yield call(fetchTenantListData, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setTenantListData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
  } catch (err) {
    yield put(setTenantListError(err));
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* fetchTenantListFunctionPaginated({ payload }) {
  yield put(setTenantListLoading(true));
  try {
    const data = yield call(fetchTenantListData, payload);
    yield put(setTenantListLoading(false));
    if (data?.status === statusCode.Ok200) {
      yield put(setTenantListDataPaginated(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
  } catch (err) {
    yield put(setTenantListLoading(false));
    yield put(setTenantListError(err));
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}
export function* deleteTenantFunction({ payload }) {
  try {
    const data = yield call(deleteTenantApi, payload);
    if (data) {
      yield put(tenantActionSuccess(data));
      yield put(tenantDeleteDataSuccess(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success?.[0]);
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(tenantActionSuccess(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* playPauseTenant({ payload }) {
  try {
    const data = yield call(playPauseTenantApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(tenantActionSuccess(data));
    } else {
      yield put(tenantActionSuccess(data));
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
  } catch (err) {
    yield put(playPauseTenantError(err));
  }
}

export function* createTenant({ data }) {
  try {
    const createTenantApiData = yield call(createTenantApi, data);
    if (createTenantApiData?.status === statusCode.Created201) {
      yield put(tenantActionSuccess(createTenantApiData));
      yield put(setTenantCreationData(createTenantApiData));
    } else {
      yield put(setTenantCreationData(createTenantApiData));
    }
  } catch (error) {
    yield put(setTenantCreationData(error));
    toastNotification(toasterFlags.ERROR, error);
  }
}

export function* editTenant({ data }) {
  try {
    const createTenantApiData = yield call(editTenantApi, data);
    if (createTenantApiData?.status === statusCode.Created201) {
      yield put(tenantActionSuccess(createTenantApiData));
      yield put(setTenantCreationData(createTenantApiData));
    } else {
      yield put(setTenantCreationData(createTenantApiData));
    }
  } catch (error) {
    yield put(setTenantCreationData(error));
  }
}

export function* viewTenant({ data }) {
  try {
    const viewTenantApiData = yield call(viewTenantApi, data);
    if (viewTenantApiData?.status === statusCode.Ok200) {
      yield put(viewTenantSuccess(viewTenantApiData));
    } else {
      toastNotification(toasterFlags.ERROR, `${viewTenantApiData?.data?.message}`);
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, `${error}`);
  }
}

export function* tenantLogoUpload({ payload }) {
  try {
    const response = yield call(uploadTemplateLogo, payload);
    if (response.status === statusCode.Ok200 || response.status === statusCode.Created201) {
      yield put(
        setTenantLogoData({
          status: response?.status,
          data: response?.data?.file,
        })
      );
    } else {
      yield put(
        setTenantLogoData({
          status: response?.status,
          data: response?.data?.file[0],
        })
      );
    }
  } catch (err) {
    yield put(setTenantLogoError(err));
  }
}

export function* getAccountManagerList({ payload }) {
  try {
    const response = yield call(getTenantUserList, payload);
    if (response.status === statusCode.Ok200 || response.status === statusCode.Created201) {
      yield put(setAccountManagers(response?.data));
    } else {
      yield put(setAccountManagersError(response));
    }
  } catch (err) {
    yield put(setAccountManagersError(err));
  }
}

export function* getCsmAdminList({ payload }) {
  try {
    const response = yield call(getTenantUserList, payload);
    if (response.status === statusCode.Ok200 || response.status === statusCode.Created201) {
      yield put(setCsmAdmins(response?.data));
    } else {
      yield put(setCsmAdminsError(response));
    }
  } catch (err) {
    yield put(setCsmAdminsError(err));
  }
}

export function* getMachineCatalogList({ payload }) {
  try {
    const response = yield call(getMachineCatalogs, payload);
    if (response.status === statusCode.Ok200 || response.status === statusCode.Created201) {
      yield put(setMachineCatalogs(response?.data));
    } else {
      yield put(setMachineCatalogError(response));
    }
  } catch (err) {
    yield put(setCsmAdminsError(err));
  }
}

export function* getTenantDetails({ payload }) {
  try {
    const response = yield call(getTenantDetailsByID, payload);
    if (response.status === statusCode.Ok200) {
      yield put(setTenantDetailsById(response?.data));
    }
  } catch (err) {
    yield put(setTenantDetailsErrorById(err));
  }
}

export function* getPricingProfileSummery({ payload }) {
  try {
    const response = yield call(pricingSummeryApi, payload);
    if (response.status === statusCode.Ok200 || response.status === statusCode.Created201) {
      yield put(successPricingProfile(response));
    } else {
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
      yield put(errorPricingProfile(response.error));
    }
  } catch (err) {
    yield put(errorPricingProfile(err));
  }
}

export function* setQuotaFromMainSaga({ payload }) {
  try {
    const response = yield call(setQuotaFormApi, payload);
    if (response.status === statusCode.Created201) {
      yield put(setQuotaFormSuccess(response?.data));
      yield put(commonLoaderSuccess());
    } else {
      yield put(commonLoaderSuccess());
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (err) {
    yield put(commonLoaderSuccess());
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* setQuotaFromGetMainSaga({ id }) {
  try {
    const response = yield call(setQuotaFormGetApi, id);
    if (response.status === statusCode.Ok200) {
      yield put(setQuotaFormGetSuccess(response?.data));
      yield put(commonLoaderSuccess());
    } else {
      yield put(commonLoaderSuccess());
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (err) {
    yield put(commonLoaderSuccess());
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* setQuotaFromUpdateMainSaga({ id, payload }) {
  try {
    const response = yield call(setQuotaFormUpdateApi, id, payload);
    if (response.status === statusCode.Ok200) {
      yield put(setQuotaFormUpdateSuccess(response?.data));
      yield put(commonLoaderSuccess());
    } else {
      yield put(commonLoaderSuccess());
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (err) {
    yield put(commonLoaderSuccess());
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* notificationSettingFromMainSaga({ payload }) {
  try {
    const response = yield call(notificationSettingFormApi, payload);
    if (response.status === statusCode.Created201) {
      yield put(notificationFormSuccess(response?.data));
      yield put(commonLoaderSuccess());
    } else {
      yield put(commonLoaderSuccess());
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (err) {
    yield put(commonLoaderSuccess());
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* notificationSettingGetMainSaga({ id }) {
  try {
    const response = yield call(notificationSettingGetApi, id);
    if (response.status === statusCode.Ok200) {
      yield put(notificationFormGetSuccess(response?.data));
      yield put(commonLoaderSuccess());
    } else {
      yield put(commonLoaderSuccess());
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (err) {
    yield put(commonLoaderSuccess());
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* notificationSettingUpdateMainSaga(payload) {
  try {
    const response = yield call(notificationSettingUpdateApi, payload);
    if (response.status === statusCode.Ok200) {
      yield put(notificationFormUpdateSuccess(response?.data));
      yield put(commonLoaderSuccess());
    } else {
      yield put(commonLoaderSuccess());
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (err) {
    yield put(commonLoaderSuccess());
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* createPricingProfileFunction({ payload }) {
  try {
    const data = yield call(createPricingProfileApi, payload);
    if (data.status === statusCode.Ok200 || data.status === statusCode.Created201) {
      yield put(setPricingProfileCreateSuccess(data));
    } else {
      yield put(setPricingProfileCreateError(data));
    }
  } catch (err) {
    yield put(setPricingProfileCreateError(err));
  }
}

export function* editPricingProfileFunction({ payload }) {
  try {
    const data = yield call(editPricingProfileApi, payload);
    if (data.status === statusCode.Ok200 || data.status === statusCode.Created201) {
      yield put(setPricingProfileEditSuccess(data));
    } else {
      yield put(setPricingProfileEditError(data));
    }
  } catch (error) {
    yield put(setPricingProfileEditError(error));
  }
}

export function* getTenantSummaryFunction({ payload }) {
  try {
    const response = yield call(fetchTenantSummary, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(setTenantSummary(response?.data));
    } else {
      yield put(setTenantSummaryError(response));
      toastNotification(toasterFlags.WARN, `${response?.data?.error}`);
    }
  } catch (error) {
    yield put(setTenantSummaryError(error));
  }
}

export function* getExtAndExpDataFunction({ payload }) {
  try {
    const response = yield call(getExtAndExpData, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(setExtAndExpData(response));
    } else {
      yield put(setExtAndExpDataError(response));
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (error) {
    yield put(setExtAndExpDataError(error));
  }
}

export function* createExtAndExpFunction({ payload }) {
  try {
    const response = yield call(createExtAndExpApi, payload);
    if (response?.status === statusCode.Created201) {
      yield put(setCreateExtAndExpData(response));
    } else {
      yield put(setCreateExtAndExpError(response));
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (error) {
    yield put(setCreateExtAndExpError(error));
  }
}

export function* updateExtAndExpFunction({ payload }) {
  try {
    const response = yield call(updateExtAndExpApi, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(setUpdateExtAndExp(response));
    } else {
      yield put(setUpdateExtAndExpError(response));
      toastNotification(toasterFlags.ERROR, `${response?.data?.message}`);
    }
  } catch (error) {
    yield put(setUpdateExtAndExpError(error));
  }
}

export function* htmlTemplateUploadFunction({ payload }) {
  try {
    const response = yield call(uploadHtmlTemplate, payload);
    if (response?.status === statusCode.Created201) {
      yield put(
        setUploadTemplateHtmlSuccess({
          status: response?.status,
          data: {
            file: response?.data?.file,
            display_name: response?.data?.display_name,
          },
        })
      );
    } else {
      yield put(
        setUploadTemplateHtmlError({
          status: response?.status,
          data: response?.data?.file[0],
        })
      );
    }
  } catch (err) {
    yield put(setUploadTemplateHtmlError(err));
  }
}

export function* fetchHtmlTemplateListFunction({ payload }) {
  try {
    const data = yield call(fetchHtmlTemplateList, payload);
    if (data.status === statusCode.Ok200) {
      yield put(setHtmlTemplateListSuccess(data));
    } else {
      yield put(setHtmlTemplateListError(data));
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
  } catch (err) {
    yield put(setHtmlTemplateListError(err));
  }
}

export function* fetchTenantSettingsFunction({ payload }) {
  try {
    const data = yield call(fetchTenantSettings, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setTenantSettingsData(data));
    } else {
      yield put(setTenantSettingsError(data));
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
    }
  } catch (err) {
    yield put(setTenantSettingsError(err));
  }
}

export function* tenantManagementRootSaga() {
  yield takeLatest(tenantManagementActions.tenantListGetData, fetchTenantListFunction);
  yield takeLatest(tenantManagementActions.GET_TENANT_LIST_PAGINATED, fetchTenantListFunctionPaginated);
  yield takeLatest(tenantManagementActions.tenantDeleteData, deleteTenantFunction);
  yield takeLatest(tenantManagementActions.tenantPlayPauseData, playPauseTenant);
  yield takeLatest(tenantManagementActions.tenantCreateRequest, createTenant);
  yield takeLatest(tenantManagementActions.tenantEditRequest, editTenant);
  yield takeLatest(tenantManagementActions.tenantViewRequest, viewTenant);
  yield takeLatest(tenantManagementActions.UPLOAD_TENANT_LOGO, tenantLogoUpload);
  yield takeEvery(tenantManagementActions.GET_ACCOUNT_MANAGER_LIST, getAccountManagerList);
  yield takeEvery(tenantManagementActions.GET_CSM_ADMIN_LIST, getCsmAdminList);
  yield takeEvery(tenantManagementActions.GET_MACHINE_CATALOG_LIST, getMachineCatalogList);
  yield takeLatest(tenantManagementActions.REQUEST_PRICING_PROFILE, getPricingProfileSummery);
  yield takeEvery(tenantManagementActions.GET_TENANT_DETAILS_BY_ID, getTenantDetails);
  yield takeEvery(tenantManagementActions.SET_QUOTA_FORM_REQUEST, setQuotaFromMainSaga);
  yield takeEvery(tenantManagementActions.SET_QUOTA_FORM_GET_REQUEST, setQuotaFromGetMainSaga);
  yield takeEvery(tenantManagementActions.SET_QUOTA_FORM_UPDATE_REQUEST, setQuotaFromUpdateMainSaga);
  yield takeEvery(tenantManagementActions.NOTIFICATION_SETTINGS_FORM_REQUEST, notificationSettingFromMainSaga);
  yield takeEvery(tenantManagementActions.NOTIFICATION_SETTINGS_GET_REQUEST, notificationSettingGetMainSaga);
  yield takeEvery(tenantManagementActions.NOTIFICATION_SETTINGS_UPDATE_REQUEST, notificationSettingUpdateMainSaga);
  yield takeLatest(tenantManagementActions.PRICING_PROFILE_CREATE_REQUEST, createPricingProfileFunction);
  yield takeLatest(tenantManagementActions.PRICING_PROFILE_EDIT_REQUEST, editPricingProfileFunction);
  yield takeLatest(tenantManagementActions.GET_TENANT_FORM_SUMMARY, getTenantSummaryFunction);
  yield takeLatest(tenantManagementActions.GET_EXTENSION_FORM_DATA, getExtAndExpDataFunction);
  yield takeLatest(tenantManagementActions.EXTENSION_FORM_CREATE, createExtAndExpFunction);
  yield takeLatest(tenantManagementActions.EXTENSION_FORM_UPDATE, updateExtAndExpFunction);
  yield takeLatest(tenantManagementActions.UPLOAD_HTML_TEMPLATE_REQUEST, htmlTemplateUploadFunction);
  yield takeLatest(tenantManagementActions.HTML_TEMPLATE_FETCH_LIST_REQUEST, fetchHtmlTemplateListFunction);
  yield takeLatest(tenantManagementActions.GET_TENANT_SETTINGS_DATA, fetchTenantSettingsFunction);
}

export default function* rootSaga() {
  yield all([fork(tenantManagementRootSaga)]);
}
